module.exports = __webpack_public_path__ + "static/img/call.817ae1.svg";